export default "__VITE_ASSET__BVtPWiD$__"